import { render, staticRenderFns } from "./OrganisationDepartments.vue?vue&type=template&id=741225b8&"
import script from "./OrganisationDepartments.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDepartments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports